import React from 'react';
import ReactDOM from 'react-dom/client';
import GroupsApp from './GroupsApp';
import './globals.css';

declare global {
  interface Window {
    DolfGroups: {
      init: () => void;
    };
  }
}

window.DolfGroups = {
  init: () => {
    const elements = document.querySelectorAll('[data-dolf-groups]');

    if (elements.length === 0) {
      console.warn('DolfGroups: No elements with data-dolf-groups attribute found');
      return;
    }

    elements.forEach((element) => {
      const roundId = parseInt(element.getAttribute('data-round') || '0');
      const apiUrl = element.getAttribute('data-api-url') || window.location.origin;

      if (!roundId) {
        console.error('DolfGroups: data-round attribute is required');
        element.innerHTML = `
          <div style="padding: 16px; border: 1px solid #f59e0b; background: #fffbeb; color: #92400e; border-radius: 8px;">
            <strong>Configuration Error:</strong> data-round attribute is required
          </div>
        `;
        return;
      }

      try {
        const root = ReactDOM.createRoot(element as HTMLElement);
        root.render(
          <React.StrictMode>
            <GroupsApp roundId={roundId} apiUrl={apiUrl} />
          </React.StrictMode>
        );
      } catch (error) {
        console.error('DolfGroups: Failed to initialize', error);
        element.innerHTML = `
          <div style="padding: 16px; border: 1px solid #dc2626; background: #fef2f2; color: #7f1d1d; border-radius: 8px;">
            <strong>Initialization Error:</strong> Failed to load Groups Widget
          </div>
        `;
      }
    });
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', window.DolfGroups.init);
} else {
  window.DolfGroups.init();
}
